export default [
  {
    path: '/usuarios',
    name: 'app-admin-usuario',
    component: () => import('@/views/apps/usuarios/users-list/UsersList.vue'),
    meta: {
      requiresAuth: true,
      action: 'read',
      resource: 'ADMIN_B2C',
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Lista de Usuários',
          active: true,
        },
        {
          text: 'Gerenciar Solicitações',
          active: false,
          to: { name: 'app-admin-usuario-solicitacoes' },
        },
      ],
    },
  },
  {
    path: '/usuarios/solicitacoes',
    name: 'app-admin-usuario-solicitacoes',
    component: () => import('@/views/apps/usuarios/users-list/UsersListSolicitacoes.vue'),
    meta: {
      requiresAuth: true,
      action: 'read',
      resource: 'ADMIN_B2C',
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Lista de Usuários',
          active: false,
          to: { name: 'app-admin-usuario' },
        },
        {
          text: 'Gerenciar Solicitações',
          active: true,
        },
      ],
    },
  },
  {
    path: '/usuarios/permissoes',
    name: 'app-admin-roles',
    component: () => import('@/views/apps/usuarios/users-list/UsersList.vue'),
    meta: {
      requiresAuth: true,
      action: 'read',
      resource: 'ADMIN_B2C',
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Cadastros',
          active: true,
        },
        {
          text: 'Usuarios',
          active: true,
        },
      ],
    },
  },
  {
    path: '/apadrinhados',
    name: 'app-admin-apadrinhados',
    component: () => import('@/views/apps/usuarios/users-list/UsersListApadrinhado.vue'),
    meta: {
      requiresAuth: true,
      action: 'read',
      resource: 'Padrinho',
      pageTitle: 'Usuarios',
      breadcrumb: [
        {
          text: 'Lista de Apadrinhados',
          active: true,
        },
      ],
    },
  },
]
